import React, { useMemo } from 'react';

import {
  PageBlockStyles,
  PageSocialNetworksBlock,
  useSocialNetworksEventsQuery,
} from '@/components/common/Providers/GraphqlProvider/generated';

import NewsSocialMedia from '../../../blocks/PageNewsletterBlock/public2/components/NewsSocialMedia';

export const EventItemSocialNetworks = () => {
  const { data: socialNetworksData } = useSocialNetworksEventsQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });

  const socialNetworks: PageSocialNetworksBlock | undefined = useMemo(() => {
    const pageBlock = socialNetworksData?.mainPage.find(
      (x) => x.__typename == 'PageSocialNetworksBlock'
    ) as PageSocialNetworksBlock;
    if (pageBlock) {
      return pageBlock;
    }
    return undefined;
  }, [socialNetworksData]);

  const blockStyle = {
    isA:
      !socialNetworks ||
      !socialNetworks.pageBlockStyle ||
      socialNetworks.pageBlockStyle === PageBlockStyles.A,
    isB: socialNetworks?.pageBlockStyle === PageBlockStyles.B,
    isC: socialNetworks?.pageBlockStyle === PageBlockStyles.C,
  };

  return (
    <div className="mt-8 flex flex-1 flex-col gap-2">
      {socialNetworks && socialNetworks.rightItems?.length > 0 && socialNetworks.pageBlockStyle && (
        <>
          <p className="font-montserrat text-[20px] font-semibold leading-[30px] text-primary">
            Nuestras redes
          </p>
          <NewsSocialMedia
            items={socialNetworks.rightItems.map((e) => ({
              id: e.id,
              link: e.linkItem?.url,
              snsSocialNetworkType: e.socialNetworkType,
              orderIndex: e.orderIndex,
            }))}
            blockStyle={blockStyle}
          />
        </>
      )}
    </div>
  );
};
